import React from "react";
import RouteCondition from "@/helper/StudentRouteCondition";
import { pages } from "@/routes/pageImports";

// Utility function to create routes with 'auth' type RouteCondition
const createAuthRoute = (path, Component) => ({
  path,
  element: <RouteCondition type="auth" Component={Component} />,
});

const createOnboardingRoute = (path, Component)=>({
  path,
  element: <RouteCondition type="onboarding" Component={Component} />
})

// Utility function to create routes with 'private' type RouteCondition and userRole 'STUDENT'
const createPrivateRoute = (path, Component) => ({
  path,
  element: (
    <RouteCondition
      type={"private"}
      userRole="STUDENT"
      Component={Component}
    />
  ),
});

// Function to define routes dynamically based on Redux state
const StudentRoutes = () => {

  // Define auth routes
  const studentAuthRoutes = [
    createAuthRoute("/student/register", pages.SignupPage),
    createAuthRoute("/student/otp", pages.CommonOtpPage),
    createAuthRoute("/student/login", pages.LoginPage),
    createAuthRoute("/student/login-otp", pages.CommonOtpPage),

    
  ];

  const studentOnboardingRoutes = [
    createOnboardingRoute("/student/personal-info", pages.PersonalInfoPage),
    createOnboardingRoute("/student/personal-doc", pages.PersonaldocumentsPage),
    createOnboardingRoute("/student/academic-info", pages.AcademicInfoPage),
    createOnboardingRoute("/student/lets-continue", pages.LetsContinuePage),
  ]

  // Define private routes
  const studentPrivateRoutes = [
    createPrivateRoute("/student/*", pages.StudentPortfolioIndex),
    createPrivateRoute("/student/edit/*", pages.EditStudentPortfolioIndex),
    createPrivateRoute("/student/template/*", pages.TemplateIndex),
    createPrivateRoute("/student/support/*", pages.SupportIndex),
    createPrivateRoute("/student/document", pages.EditPersonaldocumentsPage),
  ];

  return { studentAuthRoutes, studentPrivateRoutes, studentOnboardingRoutes };
};

export default StudentRoutes;
